import axios from 'axios';
import { GetDateInCurrentTimeZone } from 'lib/PublicFunctions';
import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { Pagination } from 'semantic-ui-react';
import Spinner from './ui/Spinner';
import moment from 'moment';

interface GroupedMessage {
  toEmail: string;
  lastEventDate: Date;
  total: number;
}

export const FailedEmails = () => {
  const [failedEmails, setFailedEmails] = useState<GroupedMessage[]>([]);
  const [totalEmails, setTotalEmails] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [currentPageEmails, setCurrentPageEmails] = useState<GroupedMessage[]>([]);
  const [loading, setLoading] = useState(false);
  const pageSize = 20;

  useEffect(() => {
    getFailedEmails();
  }, []);

  useEffect(() => {
    handlePagination();
  }, [totalEmails, pageNumber]);

  const getFailedEmails = async () => {
    setLoading(true);
    const { data } = await axios.get(`/api/failedEmails/GetFailedEmails`);
    setFailedEmails(data);
    setTotalEmails(data.length);
    setLoading(false);
  };

  const handlePagination = () => {
    if (totalEmails >= (pageNumber - 1) * pageSize) {
      setCurrentPageEmails(failedEmails.slice((pageNumber - 1) * pageSize, pageNumber * pageSize));
    }
  };

  const TableHeader = () => (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>To Email Address</Table.HeaderCell>
        <Table.HeaderCell>Total Failed</Table.HeaderCell>
        <Table.HeaderCell>Sent Date</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
  );

  const TableRow = ({ email, index }: { email: GroupedMessage; index: number }) => (
    <Table.Row key={index} style={{ position: 'relative' }}>
      <Table.Cell style={{ width: '200px' }}>{email.toEmail}</Table.Cell>
      <Table.Cell style={{ width: '200px' }}>{email.total}</Table.Cell>
      <Table.Cell style={{ width: '100px' }}>
        {moment(email.lastEventDate).format('MM-DD-YYYY')}
      </Table.Cell>
    </Table.Row>
  );

  return (
    <>
      <h1>Failed Emails</h1>
      <Table collapsing style={{ width: '900px' }}>
        <TableHeader />
        <Table.Body>
          {currentPageEmails.map((e, index) => (
            <TableRow key={index} index={index} email={e} />
          ))}
        </Table.Body>
      </Table>
      {loading && <Spinner />}
      {totalEmails > 0 && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16, marginRight: 50 }}>
          <Pagination
            disabled={loading}
            siblingRange={2}
            onPageChange={async (e, { activePage }) => {
              setPageNumber(activePage as number);
            }}
            totalPages={Math.ceil((totalEmails || 20) / 20 || 1)}
            defaultActivePage={pageNumber}
            activePage={pageNumber}
          />
        </div>
      )}
    </>
  );
};
